import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import './BackToTop.css';

// Floating back-to-top button. Appears once the page is scrolled past `threshold`.
export function BackToTop({ threshold = 500 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return (
    <button
      type="button"
      className={`back-to-top-fab${visible ? ' back-to-top-fab-visible' : ''}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      data-testid="back-to-top-fab"
    >
      <ArrowUp size={20} />
    </button>
  );
}
